import React from "react";
import {defaultBreakpoints, SwiperWithTitleAndItems} from "../crossSelling/SwiperBuilder";
import {useTranslation} from "react-i18next";
import {LookItemType} from "./LookTypes";
import {BreakpointType} from "../../molecules/SwiperTypes";
import {useUnsafeCartContext} from "../../cart/CartContextProvider/CartContextProvider";

const lookProductsBreakpoints: BreakpointType = {...defaultBreakpoints};
if (lookProductsBreakpoints["941"]) {
  lookProductsBreakpoints["941"] = {
    ...lookProductsBreakpoints["941"],
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
  };
}

const LookProductsSlider: React.FC<{lookItems: LookItemType[] | null}> = ({lookItems}) => {
  const {t} = useTranslation();
  const context = useUnsafeCartContext();

  if (!lookItems) {
    return null;
  }

  const reducedItemsMap = new Map(lookItems.map((li) => [li.productId, li]));
  const reducedItems = Array.from(reducedItemsMap).map((li) => li[1].item);

  return (
    <div className="pos-rel">
      <SwiperWithTitleAndItems
        title={t("shopthelook.productsFromThisLook")}
        items={reducedItems}
        context={context}
        breakpoints={lookProductsBreakpoints}
      />
    </div>
  );
};

export default LookProductsSlider;
